<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'成功案例配置',goback:true},{name:'新增成功案例'}]" :title="'新增成功案例'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                  <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                  >
                    <el-form-item label="案例内容" prop="content">
                      <el-input v-model="ruleForm.content"></el-input>
                    </el-form-item>
                    <el-form-item label="数据类型" prop="type">
                      <el-select v-model="ruleForm.type" placeholder="请选择">
                        <el-option label="需求发布" :value="0"></el-option>
                        <el-option label="融资动态" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="resetForm('ruleForm')">取消</el-button>
                      <el-button type="primary" @click="submitForm('ruleForm')" :loading="subLoading" :disabled="subLoading">确认</el-button
                      >
                    </el-form-item>
                  </el-form>
                    
                    
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
    components:{
        breadcrumb,
    },
    data(){
        return{
          subLoading:false,
            edit:false,
            id:void 0,
            ruleForm: {
              content: null,
              type: void 0 // 类型：0=需求发布，1=融资动态
            },
            rules: {
              content: [
                { required: true, message: "请输入案例内容", trigger: "blur" },
              ],
              type: [
                { required: true, message: "请选择数据类型", trigger: "blur" },
              ],
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    methods:{
		getDetail(id){
			this.$axiosz.get('backstage/administrator/echo',{params:{id}}).then((r)=>{
			    if(r.code==200){
                        this.sendInfoTwo.dto.realName=r.data.realName;
                        this.sendInfoTwo.dto.userName=r.data.userName;
                        this.sendInfoTwo.dto.administratorType=r.data.administratorType;
                        this.transferList=[...r.data.notSelectRoles,...r.data.selectRoles];
                        if(r.data.selectRoles){
                            for(let item of r.data.selectRoles){
                                this.sendInfoTwo.dto.roleIds.push(item.id);
                            }
                        }
                    }else{
                        this.$alert(r.msg)
                    }
			})
		},
      resetForm(formName) {
      // this.ruleForm = {
      //   content: null,
      // };
      // this.$refs[formName].resetField();
      this.$router.back(-1)
    },
        //保存按钮
        submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.edit) {
            if(this.subLoading) return 
            this.subLoading = true
            this.$axiosc
              .post(`/backstage/hotCase/add?content=${this.ruleForm.content}&type=${this.ruleForm.type}`)
              .then((r) => {
                this.subLoading = false
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  // this.getData();
                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              }).catch(e=>{
                this.subLoading = false
              })
          } else {
            this.$axioscBody
              .put("/backstage/hotCase/edit", this.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });

                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>
